<template>
    <!-- Added CSS support for empty label -->
    <label class="checkbox-container" @click.stop=""
        ><span v-if="labelHtml" v-html="labelHtml" class="label" /><span v-else class="label">{{ label }}</span>
        <input
            type="checkbox"
            :checked="checked"
            :required="required"
            :name="name"
            @change.prevent="handle($event)"
            :disabled="disabled"
            @focus="hasFocus = true"
            @blur="hasFocus = false"
        />
        <span :class="{ checkmark: true, disabled: disabled, 'focus-visible': hasFocus }"></span>
    </label>
</template>
<script>
export default {
    props: {
        value: undefined, // String or Boolean
        name: undefined,
        label: String,
        labelHtml: String,
        handler: Function,
        disabled: Boolean,
        required: Boolean,
        q: String,
    },
    data() {
        return {
            checked: this.value === "true" || this.value === "on" || this.value === true ? true : false,
            hasFocus_: false,
        };
    },
    methods: {
        handle(event) {
            // this.checked = event.target.checked;
            const isChecked = event.target.checked ? "on" : "";
            if (this.handler) {
                this.handler(event);
            }
            this.$emit("input", Boolean(isChecked));
        },
    },
    computed: {
        hasFocus: {
            get() {
                return this.hasFocus_;
            },
            set(value) {
                this.hasFocus_ = value;
            },
        },
    },
    watch: {
        value() {
            this.checked = this.value === "true" || this.value === "on" || this.value === true ? true : false;
        },
    },
};
</script>
<style lang="sass" scoped>
@import "@/style/variables"

/* Bootstrap - Start */
@import "bootstrap/scss/functions"
@import "bootstrap/scss/variables"
@import "bootstrap/scss/mixins"
@import "bootstrap/scss/root"
@import "bootstrap/scss/reboot"

@import "bootstrap/scss/forms"
/* Bootstrap - End */

@import "@/style/deprecated_main"

.checkbox-container
    display: inline-block
    position: relative
    padding-left: 35px /* Distance between text and left side of checkbox */
    margin: 0
    min-width: 0px !important /* Needs to be defined and !important, otherwise overwritten by .product-selection .group > button [role=presentation] with min-width 160px */
    min-height: 21px /* Needs to be set in case label is empty */
    cursor: pointer
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    user-select: none
    mark
        padding: 0px

    input
        position: absolute
        opacity: 0
        cursor: pointer
        height: 0
        width: 0

    input:checked ~ .checkmark
        background-color: #CA346F

    input:checked ~ .checkmark:after
        display: block

    .checkmark
        position: absolute
        top: 0
        left: 0
        height: 24px
        width: 24px
        border: 1px solid #728296
        border-radius: 4px
        background-color: #FFFFFF

        &.disabled
            //background-color: #F0F3F8
            //border: 1px solid #CFD5DD
            opacity: 0.4

    &[role="presentation"] .checkmark
        margin-top: 4px

    .checkmark:after
        content: ""
        position: absolute
        display: none
        left: 9px
        top: 5px
        width: 5px
        height: 10px
        border: solid white
        border-width: 0 3px 3px 0
        -webkit-transform: rotate(45deg)
        -ms-transform: rotate(45deg)
        transform: rotate(45deg)

    .focus-visible
        outline: -webkit-focus-ring-color auto 1px
        outline-color: -webkit-focus-ring-color
        outline-style: auto
        outline-width: 1px

    .label
        color: #728296
</style>
